import { useState, useEffect } from "react";
import { ResizeObserver } from "@juggle/resize-observer";
import debounce from "lodash/throttle";

function useVh(percent = 100, option) {
  const { delay = 1000, adjust = 0, validateWith } = option ?? {};

  const [vhHeight, setVhHeight] = useState(window.innerHeight + adjust);
  useEffect(() => {
    const handleChange = debounce(() => {
      const newVhHeight = window.innerHeight * (percent / 100);
      const adjustedHeight = newVhHeight + adjust;

      if (!validateWith || adjustedHeight >= validateWith) {
        setVhHeight(adjustedHeight);
      }
    }, delay);

    const observer = new ResizeObserver(handleChange);
    observer.observe(document.documentElement);

    window.addEventListener("orientationchange", handleChange);
    window.addEventListener("resize", handleChange);
    window.screen?.orientation?.addEventListener("change", handleChange);

    return () => {
      observer.unobserve(document.documentElement);
      window.removeEventListener("resize", handleChange);
      window.removeEventListener("orientationchange", handleChange);
      window.screen?.orientation?.removeEventListener("change", handleChange);
    };
  }, [percent, adjust, delay, validateWith]);

  return vhHeight;
}

export default useVh;
